module.exports = __webpack_public_path__ + "fonts/AvenirNextCondensed-Bold.4b691625.woff2";